import React, { useCallback, useState } from 'react'

import { TextButtonContent } from 'common/builder/components/chart/FlowChart/components/Button/TextButtonContent/TextButtonContent'
import { useButtonStyle } from 'common/builder/components/chart/FlowChart/components/Button/useButtonStyle'
import { ExposeCoordinatesView } from 'common/builder/components/chart/FlowChart/components/ExposeCoordinatesView/ExposeCoordinatesView'
import { useButtonName } from 'common/builder/components/chart/FlowChart/hooks/useButtonName'
import {
  ButtonAppearance,
  FlowChartButton,
} from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import { DefaultButtonContent } from './DefaultButtonContent/DefaultButtonContent'
import { DefaultCenteredButtonContent } from './DefaultCenteredButtonContent/DefaultCenteredButtonContent'
import { MenuButtonContent } from './MenuButtonContent/MenuButtonContent'
import { ButtonContentComponent } from './types'

const AppearanceToContentMapping: Partial<Record<ButtonAppearance, ButtonContentComponent>> = {
  [ButtonAppearance.MENU]: MenuButtonContent,
  [ButtonAppearance.DEFAULT_CENTERED]: DefaultCenteredButtonContent,
  [ButtonAppearance.TEXT]: TextButtonContent,
}

interface ButtonProps {
  button: FlowChartButton
  style?: React.CSSProperties
}

export const Button = ({ button, style: externalStyle }: ButtonProps) => {
  const [isHover, setIsHover] = useState(false)
  const buttonName = useButtonName(button)
  const handleOnHover = useCallback(() => setIsHover(true), [])
  const handleOnBlur = useCallback(() => setIsHover(false), [])

  const ButtonContentComponent =
    AppearanceToContentMapping[button.appearance] || DefaultButtonContent

  const style = useButtonStyle(button.appearance, isHover, externalStyle)

  return (
    <ExposeCoordinatesView
      id={button.id}
      name={buttonName}
      onMouseOver={button.isInteractive ? handleOnHover : undefined}
      onMouseOut={button.isInteractive ? handleOnBlur : undefined}
      style={style}
    >
      <ButtonContentComponent button={button} isHover={isHover} />
    </ExposeCoordinatesView>
  )
}
